module.exports = __webpack_public_path__ + "static/a1-8cf6d19a65d6d8450ced950d65699aa5.jpg";